<template>
    <div>
        <!-- ADDRESS -->
        <div class="form-group">
          <label class="control-label"><span class="sr-only">
            Address
          </span>
          <input
            @focus="handleAddressFocus"
            @keyup="handleAddressKeyup"
            ref="autocomplete"
            v-model="syncAddress"
            type="text"
            class="form-control"
            :placeholder="placeholder"
            :class="inputClass"
            >

          </label>
        </div>
        <ul v-if="autocompleteResults.length" class="autocomplete-results">
          <li v-for="result in autocompleteResults" @click.prevent="handleAddressResultSelected(result)">
            <span v-html="result.html">
            </span>
          </li>
        </ul>
    </div>
</template>
<script>


export default {
    data: function(){
        return {
          autocompleteService: null,
          autocompleteTimeout: null,
          autocompleteResults: [],
          selectedPrediction: null,
        }
    },
    props:{
      address: String,
      inputClass: String,
      placeholder: {
        type : String,
        required : false,
        default : __('webapp.address')
      }
    },
    computed:{
      syncAddress:{
        get(){
          return this.address;
        },
        set(val){
          this.$emit('update:address',val);
        }
      }
    },
    created(){
      this.autocompleteService = new google.maps.places.AutocompleteService();
    },
    mounted(){
      var obj = jQuery('<div>').appendTo('body');
      this.placesService = new google.maps.places.PlacesService(obj.get(0));
    },
    methods:{
      handleAddressResultSelected(result){
        this.selectedResult = result;
        this.syncAddress = result.description;
        this.autocompleteResults = [];

        this.placesService.getDetails({placeId: result.place_id},(prediction,status) => {

          if(status == google.maps.places.PlacesServiceStatus.OK){
            this.selectedPrediction = prediction;
            this.$emit('change',prediction);
            this.selectedCoordinates = [
              {lat: prediction.geometry.location.lat},
              {lng: prediction.geometry.location.lng},
            ];
          }
        })
      },
      handleAddressFocus(evt){
        var value = evt.target.value;
        this.autocompleteResults = [];
      },
      handleAddressKeyup(evt){
        var value = evt.target.value
        if(!value){
          this.autocompleteResults = [];
          return;
        }

        window.clearTimeout(this.autocompleteTimeout);

        this.autocompleteTimeout = window.setTimeout(() => {
          this.autocompleteService.getPlacePredictions({
            input: value,
          }, (predictions,status) => {
            predictions = predictions.map((p) => {
              var html = `<span>${p.description}</span>`;

              p.matched_substrings.forEach((match) => {
                var matchStr = p.description.substring(match.offset,match.offset + match.length);
                html = html.replace(matchStr,`<b>${matchStr}</b>`)
              });
              p.html = html;
              return p;
            });

            if(status == 'OK'){
              this.autocompleteResults = predictions;
            }
          });
        },350)
      },
    }
}
</script>

<style scoped>
  .autocomplete-results{
    background-color: #fbfbfb;
    list-style: none;
    margin: 0;
    padding: 0;
    border: 1px solid #eee;
    position: relative;
    z-index: 1000;
    width: 100%;
  }

  .autocomplete-results li{
    font-size: 14px;
    border-bottom: 1px solid #ececec;
    padding-bottom: 10px;
    padding-left: 10px;
    padding-top: 10px;
  }

  .autocomplete-results li:hover{
    background-color: #eee;
  }
</style>
